import { render } from "./index.vue?vue&type=template&id=273d266c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=273d266c&lang=less&scoped=true"

import exportComponent from "/Users/aleksandrzulaev/Sites/Landings/appsguru.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273d266c"]])

export default __exports__